export const STRIPE_KEY = getServerConstantsValue("STRIPE_PUBLIC_KEY") ;
export const CONSULTANT_SUBSCRIPTION_PAYMENT = parseInt(getServerConstantsValue("CONSULTANT_SUBSCRIPTION_AMOUNT"));